import Vue from "vue";
import _ from "lodash";
import VueRouter from "vue-router";
import "@/lib/polyfills";
import "../../sass/vendor.scss";
import "../../sass/core.scss";

import PickPriceDrive from "@/components/PickPriceDrive";
import VueI18n from "vue-i18n";
import Vuex from "vuex";
import pathify from "@/store/pathify";
import user from "@/store/modules/user";
import translated from "@/store/modules/translated";
import location from "@/store/modules/location";
import campaign from "@/store/modules/campaign";
import sessionReset from "@/store/modules/sessionReset";
import configure from "@/store/modules/configure";
import shopBy from "@/store/modules/shopBy";
import headerTransitionStore from "@/store/modules/headerTransitionStore";
import CarSaverPlugin from "@/lib/CarSaverPlugin";
import PaymentPage from "Modules/ShopBy/Payment";
import BodyStylePage from "Modules/ShopBy/BodyStyle";

const environment = _.get(window, "appConfig.env[0]", "local") || "local";

Vue.use(Vuex);
Vue.use(VueI18n);

const debug = environment !== "production";

const store = new Vuex.Store({
    plugins: [pathify.plugin],

    modules: {
        user,
        translated,
        location,
        sessionReset,
        campaign,
        configure,
        shopBy,
        headerTransitionStore
    },
    strict: debug
});

Vue.use(CarSaverPlugin);
Vue.use(VueRouter);

const defaultMessages = _.get(store, "state.translated.text", {});
const messages = {
    default: defaultMessages,
    en: {},
    es: {}
};
const i18n = new VueI18n({
    locale: "default",
    fallbackLocale: "default",
    messages
});

const routes = [
    {
        path: "/shop-by/payment",
        component: PaymentPage,
        props: true,
        meta: {
            next: {
                to: "payment/body-style"
            },
            breadcrumbs: [
                {
                    text: "Shop By",
                    href: "/shop-by"
                },
                {
                    text: "Payment",
                    active: true
                }
            ]
        }
    },
    {
        path: "/shop-by/payment/body-style",
        component: BodyStylePage,
        props: true,
        meta: {
            next: {
                modelsPage: true
            },
            breadcrumbs: [
                {
                    text: "Shop By",
                    href: "/shop-by"
                },
                {
                    text: "Payment",
                    href: "/shop-by/payment"
                },
                {
                    text: "Body Style",
                    active: true
                }
            ],
            pageTitle: "Payment"
        }
    }
];

const router = new VueRouter({
    mode: "history",
    routes
});

if (document.getElementById("root") != null) {
    // eslint-disable-next-line no-new
    new Vue({
        el: "#root",

        router,

        store,

        i18n,

        components: {
            PickPriceDrive
        }
    });
}
